import { CONNECTION_UI_STATE, connectionUiState } from '@/features/integrations'

/** Toolkit slug -> its connection, so a card can render live state. */
export function indexConnectionsBySlug(connections) {
  const bySlug = new Map()
  for (const connection of connections ?? []) {
    const slug = String(connection.toolkit_slug ?? '').toLowerCase()
    if (!slug) continue
    // Prefer an ACTIVE row when a toolkit has more than one; a stale FAILED
    // attempt must not mask a working connection.
    const existing = bySlug.get(slug)
    if (!existing || connection.status === 'ACTIVE') bySlug.set(slug, connection)
  }
  return bySlug
}

/** Provider toolkit + its connection -> everything a card needs to render. */
export function toCard(toolkit, connection) {
  const state = connectionUiState(connection)
  return {
    slug: toolkit.slug,
    title: toolkit.name,
    description: toolkit.description ?? '',
    icon: toolkit.logo ?? undefined,
    categories: toolkit.categories ?? [],
    connectionId: connection?.id ?? null,
    state,
    noAuth: Boolean(toolkit.no_auth),
    // Two separate reasons a Connect button stays dark, and the user is told
    // which: the app cannot be connected at all, or it can but the agent has
    // no read-only actions for it yet.
    canConnect: !toolkit.no_auth && Boolean(toolkit.connectable) && Boolean(toolkit.supported),
    unavailableReason: unavailableReason(toolkit),
    isConnected: state === CONNECTION_UI_STATE.connected,
  }
}

function unavailableReason(toolkit) {
  if (toolkit.no_auth) return 'This app works without a connection.'
  if (!toolkit.connectable) return 'This app cannot be connected yet.'
  if (!toolkit.supported) return 'Not yet supported by the assistant.'
  return null
}
